import axiosRequest, { AxiosResponse } from 'axios';
import { getAccessToken } from 'shared/helpers/token'

export type AbstractRequest = (props: { options: any; authenticate?: boolean; maxRetries?: number; }) => Promise<AxiosResponse>;

export const request: AbstractRequest =  async ({ options, authenticate = true, maxRetries = 3 }): Promise<AxiosResponse> => {
    const token = getAccessToken();
    const domainName = window.location.host
    return axiosRequest({
        ...options,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'domain': domainName,
            ...(authenticate && {
                'Authorization': 'Bearer ' + token,
            }),
            ...options.headers,
        }
    }).catch((e) => {
        throw(e);
    });
};